import { render, staticRenderFns } from "./RouteLink.vue?vue&type=template&id=6ecddf84&scoped=true&"
import script from "./RouteLink.vue?vue&type=script&lang=js&"
export * from "./RouteLink.vue?vue&type=script&lang=js&"
import style0 from "./RouteLink.vue?vue&type=style&index=0&id=6ecddf84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecddf84",
  null
  
)

export default component.exports